module.exports = __webpack_public_path__ + "img/dinkenclave-10.5de0f0d1.jpeg";